import { keyBy } from 'lodash';

import { AUTH0_USER_ROLES } from './constants';

export default function assignReadEventsAccess(members) {
  return members.map(member => {
    const roleMap = keyBy(member.roles, 'name');

    return {
      ...member,
      metadata: {
        readEvents: Boolean(roleMap[AUTH0_USER_ROLES.READ_EVENTS]),
      },
    };
  });
}
